import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { Copy } from "lucide-react"; // lightweight copy icon

const SocialShareButton = ({ url, title, description, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef(null);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setIsOpen((prev) => !prev);
  };

  // Close popup when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // Popup markup using portal
  const popupContent = (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        backdropFilter: "blur(8px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        ref={popupRef}
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
          borderRadius: "20px",
          padding: "24px",
          minWidth: "300px",
          maxWidth: "90%",
          boxShadow: "0 8px 30px rgba(0,0,0,0.4)",
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          color: "#fff",
          fontFamily: "Manrope",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          Share this Moment ✨
        </h3>

        {/* Social buttons */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "center",
          }}
        >
          {shareOptions.map((option) => (
            <a
              key={option.name}
              href={option.href(url, title, description)}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                ...socialButtonStyle,
                background: "rgba(255, 255, 255, 0.18)",
                border: "1px solid rgba(255, 255, 255, 0.25)",
              }}
            >
              <img
                src={option.icon}
                alt={option.name}
                style={{ width: 36, height: 36 }}
              />
            </a>
          ))}
        </div>

        <hr
          style={{
            borderColor: "rgba(255,255,255,0.2)",
            margin: "12px 0",
          }}
        />

        {/* Copy Link */}
        <button
          onClick={() => {
            navigator.clipboard.writeText(url);
            alert("Link copied to clipboard!");
          }}
          style={{
            background: "rgba(255, 255, 255, 0.18)",
            border: "1px solid rgba(255, 255, 255, 0.25)",
            padding: "10px 14px",
            borderRadius: "12px",
            cursor: "pointer",
            color: "#fff",
            fontWeight: 600,
            fontFamily: "Manrope",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            transition: "all 0.25s ease",
          }}
        >
          <Copy size={18} />
          Copy Link
        </button>
      </div>
    </div>
  );

  return (
    <>
      <button
        onClick={toggleDropdown}
        style={{
          ...style,
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "#fff",
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <img
          src="/Share.svg"
          alt="Share"
          style={{ width: "16px", height: "16px" }}
        />
        Share
      </button>

      {isOpen && ReactDOM.createPortal(popupContent, document.body)}
    </>
  );
};

// --- Share options with icons ---
const shareOptions = [
  {
    name: "Facebook",
    icon: "/facebook.png",
    href: (url) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    name: "Twitter",
    icon: "/twitter.png",
    href: (url, title) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(title)}`,
  },
  {
    name: "Instagram",
    icon: "/instagram.png",
    href: () => "https://www.instagram.com/your_username/",
  },

  // {
  //   name: "WhatsApp",
  //   icon: "/whatsapp-icon.svg",
  //   href: (url, title) =>
  //     `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`,
  // },
  // {
  //   name: "Email",
  //   icon: "/email-icon.svg",
  //   href: (url, title, description) =>
  //     `mailto:?subject=${encodeURIComponent(
  //       title
  //     )}&body=${encodeURIComponent(`${description}\n${url}`)}`,
  // },
];

// --- Common styles ---
const socialButtonStyle = {
  width: "48px",
  height: "48px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  cursor: "pointer",
  transition: "all 0.3s ease",
};

export default SocialShareButton;
